import { useEffect, useState } from 'react';
import type { Session, User } from '@supabase/supabase-js';
import { supabase } from '@/utils/supabase';

interface UseSupabaseUserResult {
  session: Session | null;
  user: User | null;
  loading: boolean;
}

/**
 * Sessão do cidadão autenticado no Supabase Auth.
 * O callback de onAuthStateChange é síncrono (apenas atualiza o estado local),
 * conforme as boas práticas de Auth — nenhum acesso ao banco dentro do callback.
 */
export function useSupabaseUser(): UseSupabaseUserResult {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    supabase.auth
      .getSession()
      .then(({ data }) => {
        if (!active) return;
        setSession(data.session);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setSession(null);
        setLoading(false);
      });

    const { data: subscription } = supabase.auth.onAuthStateChange((_event, nextSession) => {
      setSession(nextSession);
    });

    return () => {
      active = false;
      subscription.subscription.unsubscribe();
    };
  }, []);

  return { session, user: session?.user ?? null, loading };
}